import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, ProductService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-how-to-open-pool-for-season',
    templateUrl: './how-to-open-pool-for-season.component.html',
    styleUrls: ['./how-to-open-pool-for-season.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class HowToOpenPoolForSeasonComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/PoolInSpringTime.webp',
    metaDescription: `As the weather warms up, it's time to prepare your pool for another season of fun and relaxation. Learn how to open your pool for the season with our guide.`,
    metaTitle: `How to Open Your Pool for the Season`
  };
  public spinner$: Observable<NgxSpinner>;
  public blogPost!: IBlogPost;
  public stowAway: IShopifyProduct | undefined;
  public complete911: IShopifyProduct | undefined;
  public simplySanitizer: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/how-to-open-pool-for-season');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.HOW_TO_OPEN_POOL_FOR_SEASON);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.stowAway = await this.productService.loadProductByHandle('bioguard-stow-away');
    this.complete911 = await this.productService.loadProductByHandle('bioguard-pool-complete-911');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
